import { BulleAide, FieldRadioGroup, Question } from '@workspace/core-ts/components';
import { SmartFormGlobal, useSmartFormGlobal } from '@workspace/core-ts/contexts';
import { Calendar, Sinistres, Warning } from '@workspace/core-ts/icons-amo';
import { booleanOptions } from '@workspace/utils';
import type { FormSchemaType } from '../schema';

export default function Declaration() {
    const methods = useSmartFormGlobal<FormSchemaType>();
    const isAvenant = methods.watch('DemandeTarif.ActeGestion') === 'AV';

    return (
        <SmartFormGlobal {...methods} className="mx-auto">
            <Question>
                <Question.Header>
                    <Calendar />
                    <Question.Title>
                        Vous déclarez que le <b>conducteur</b> de chaque véhicule aura <b>entre 18 et 65 ans inclus</b> et qu’il sera en possession d’un <b>permis de conduire de l’UE valide</b> en adéquation avec le véhicule ?
                    </Question.Title>
                </Question.Header>
                <FieldRadioGroup
                    name="DemandeTarif.DevoirConseil.Vehicule1865"
                    options={booleanOptions}
                    validation={{
                        validate: (value) => (value ? true : 'Chaque conducteur pour chaque véhicule doit être agé entre 18 et 65 ans inclus'),
                    }}
                />
            </Question>

            <Question>
                <Question.Header>
                    <Question.Title>
                        Vous déclarez que la flotte de véhicules est utilisée uniquement pour des
                        <b> déplacements professionnels</b>. Elle ne sert en aucun cas pour des
                        déplacements privés, même occasionnels.
                    </Question.Title>
                </Question.Header>
                <FieldRadioGroup
                    name="DemandeTarif.DevoirConseil.UsageExclusifProfessionnel"
                    options={booleanOptions}
                    validation={{
                        validate: (value) => (value ? true : 'Chaque véhicule doit être utilisé pour des déplacements professionnels uniquement'),
                    }}
                />
            </Question>

            <Question active={!isAvenant}>
                <Question.Header>
                    <Sinistres />
                    <Question.SubTitle>Au cours des 24 derniers mois...</Question.SubTitle>
                    <Question.Title>
                        Votre flotte a-t-elle plus de <b>2 sinistres par véhicule</b> ?
                    </Question.Title>
                </Question.Header>

                <BulleAide icon={<Warning />} title="Attention !">
                    <p>Par exemple, si votre flotte assurée contient 3 véhicules, le nombre de sinistre ne doit pas dépasser 6 dans les 24 derniers mois.</p>
                    <p>
                        Pour finaliser la souscription, un <b>Relevé d'Information</b> sera demandé pour attester le nombre de sinistre pour votre véhicule ou la flotte de véhicules.
                    </p>
                </BulleAide>

                <BulleAide>
                    <p>Dans le cas d’une création de flotte, une attestation sur l’honneur sera demandée pour valider la souscription.</p>
                    <p>Si la date de création de la société est inférieure à 3 mois, vous pouvez répondre « Non » sans justificatif.</p>
                </BulleAide>

                <FieldRadioGroup
                    name="DemandeTarif.DevoirConseil.Sinistre24Mois"
                    options={booleanOptions}
                    validation={{
                        validate: (value) => (value ? "Nous n'assurons pas les flottes de véhicules qui ont plus de 2 sinistres par véhicule" : true),
                    }}
                />
            </Question>
        </SmartFormGlobal>
    );
}
